import styled from "styled-components";
import Fade from "react-reveal/Fade"



const Niche = () => {
    return(
        <Container>
            <NicheCaption>
                <span>Transparent Process</span>
                <h2>Why People Choose Us</h2>
                <p>Productivity is never an accident. It is always the result of a commitment to excellence, intelligent planning, and focused effort.</p>
            </NicheCaption>
            <NicheCards>
            
                    <Card>
                        <div></div>
                        <span><i class="fa fa-university" aria-hidden="true"></i></span>
                        <h2>Reliability</h2>
                        <p>There is no finish line when it comes to our system's reliability and availability</p>
                    </Card>
            
                    <Card>
                        <div></div>
                        <span><i class="fa fa-university" aria-hidden="true"></i></span>
                        <h2>Credibility</h2>
                        <p>Credibility is our currency. Without character, there is no credibility; and without credibility, there is no trust.</p>
                    </Card>
                
                
                    <Card>
                        <div></div>
                        <span><i class="fa fa-university" aria-hidden="true"></i></span>
                        <h2>Accessibility</h2>
                        <p>We are always accessible to our customers whenever we are needed</p>
                    </Card>
            </NicheCards>
            <NicheValues>
                <div className="NicheImage">
                    <img src="/images/gallery/niche.jpg" alt=""/>
                </div>
                <ValuesDetail>
                    <h2>Our company values</h2>
                    <Values>
                        <span><i class="fa fa-university" aria-hidden="true"></i></span>
                        <div>
                            <h3>Innovative</h3>
                            <p>Bringing in some creativity to the operational system of our services, through reliability, credibility, accessibility and not forgetting simplicity as a company value, has made us second to none.</p>
                        </div>
                    </Values>
                    <Values>
                        <span><i class="fa fa-users" aria-hidden="true"></i></span>
                        <div>
                            <h3>Talent</h3>
                            <p>One of our greatest company value is bringing out the talent(greatness) in every individual by supporting them in every possible way within our capacity.</p>
                        </div>
                    </Values>
                    <Values>
                        <span><i class="fa fa-podcast" aria-hidden="true"></i></span>
                        <div>
                            <h3>Enabling</h3>
                            <p>Creating an enabling platform for innovation and talent is a core company value at <b>Winnthako</b>. Seeing dreams becoming real and impossibility becoming possibilities is a sure key to greatness to us.</p>
                        </div>
                    </Values>
                    <Values>
                        <span><i class="fa fa-bath" aria-hidden="true"></i></span>
                        <div>
                            <h3>Commercially Responsible</h3>
                            <p>Commercial responsibility is a key tool for success in all endeavours. Hence, not taking for granted but taking seriously every opportunity that comes our way is a pivotal criteria at <b>Winnthako</b></p>
                        </div>
                    </Values>
                </ValuesDetail>
            </NicheValues>
        </Container>
    )
}


const Container = styled.div`
    
    background: rgb(249, 250, 251);
    padding: 0px 20px;

    @media(min-width: 768px){
        padding: 100px 20px;
    }
    
`

const NicheCaption = styled.div`
    text-align: center;
    padding: 20px;

    span{
        color: rgb(231, 60, 62);
    }
    p{
        font-color: rgb(96, 96, 96);
    }

    @media(min-width: 768px){
        h2{
            font-size: 36px;
            margin: 10px 0 0 0;
        }
        p{
            margin: 10px 0 0 0;
        }
    }
`
const NicheCards = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    @media(min-width: 768px){
        flex-direction: row;
        margin-top: 50px;
    }

    span{
        font-size: 40px;
        color: rgb(231, 60, 62);
        border-radius: 50%;
        background: white;
        padding: 10px 15px;
        position: relative;

        @media(min-width: 768px){
            padding: 20px 25px;
        }

    }

`

const Card = styled.div`
    background: rgb(255, 255, 255);
    margin-bottom: 50px;
    padding: 50px 20px;
    position: relative;
    overflow: hidden;
    transition: 0.5s ease; 

    @media(min-width: 768px){
        width: 24%;
        h2{
            font-size: 25px;
        }
        p{
            line-height: 28.8px;
        }
    }

    &:hover { 
       transform: translateY(-20px);
       transition: transform 0.5s ease;

        
        span {
            background: rgb(231, 60, 62);
            color: rgb(255, 255, 255);
            transition: 0.5s ease;
           
        }
    }

    div{
        width: 90%;
        height: 80%;
        background: rgb(253, 235, 235);
        position: absolute;
        border-radius: 50%;
        top: -60%;
        left: 5%;

        @media(min-width: 768px){
            width: 98%;
            left: calc(2%/2);
            top: -55%;
        }
        
    
    }
    
}
`
const NicheValues = styled.div`
    background: rgb(255, 255, 255);
    img{
        width: 100%;
    }



    @media(min-width: 768px){
        display: flex;

        .NicheImage{
            width: 60%;
            img{
                width: 100%;
                height: 100%;
                //object-fit: contain;
            }
        }
    } 
`

const ValuesDetail = styled.div`
    @media(min-width: 768px){
        width: 40%;
        padding: 20px;
    }

`

const Values = styled.div`
    display: flex;
    justify-content: space-around;

    @media(min-width: 768px){
        align-items: flex-start;
    }

    span{
        font-size: 30px;
        color: rgb(231, 60, 62);
        display: inline-block;
        width: 10%;
        font-weight: 400;
    }

    div{
        width: 80%;
        
        h3{
            margin: 0;

            @media(min-width: 768px){
                font-size: 25px;
            }
        }
    }


`
export default Niche;